import React, { Fragment } from 'react'
import Scroll from 'react-scroll'
import PropTypes from 'prop-types'
import ReactPagination from 'react-js-pagination'

import { RuleRunner, run } from 'Pods/Shared/RuleRunner'
import { required } from 'Pods/Shared/Rules/Rules'
import TextareaField from 'Pods/Shared/TextareaField'
import CustomRadioBoxes from 'Pods/Shared/Checkbox/CustomRadioBoxes'
import Icon from 'Pods/Shared/Icon/Icon'
import Progressbar from 'Pods/Shared/Progressbar'

import ItemRating from './Components/ItemRating'

const fieldValidations = [
  RuleRunner('comment', 'Comment', required),
]

class ItemRatings extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      itemRatings: props.data.data,
      meta: props.data.meta,
      showErrors: false,
      disableButton: false,
      comment: '',
      score: '1',
      isSignedIn: false,
      isAdmin: false,
    }

    this.commentBoxRef = React.createRef()
    this.onFetchSuccess = this.onFetchSuccess.bind(this)
    this.onPaginate = this.onPaginate.bind(this)
    this.removeItemRating = this.removeItemRating.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onScoreChange = this.onScoreChange.bind(this)
    this.scrollToCommentBox = this.scrollToCommentBox.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.setState({
      validationErrors: run(this.state, fieldValidations),
      isSignedIn: App.config.userSignedIn,
      isAdmin: App.config.isAdmin || false,
    })
  }

  scrollToCommentBox() {
    const rect = this.commentBoxRef.current.getBoundingClientRect()
    Scroll.animateScroll.scrollTo(rect.top)
  }

  onPaginate(pageNumber) {
    axios.get(`/api/internal/items/${this.props.itemId}/item-ratings`, { params: { page: pageNumber } })
      .then(this.onFetchSuccess)
      .catch((error) => { })
  }

  onFetchSuccess(response) {
    this.setState({ itemRatings: response.data.data, meta: response.data.meta })
  }

  removeItemRating(itemRatingId) {
    axios.delete(`/api/internal/item_ratings/${itemRatingId}`)
      .then(this.onSubmitSuccess).catch(this.onSubmitFailure)
  }

  handleInputChange(event) {
    const newState = this.state

    newState.comment = event.target.value
    newState.validationErrors = run(newState, fieldValidations)

    this.setState(newState)
  }

  handleSubmit(event) {
    event.preventDefault()

    this.setState({
      showErrors: true,
      disableButton: true,
      validationErrors: run(this.state, fieldValidations),
    })

    if (Object.getOwnPropertyNames(this.state.validationErrors).length === 0) {
      axios.post(`/api/internal/items/${this.props.itemId}/rate`,
        {
          data: {
            attributes: {
              comment: this.state.comment,
              score: this.state.score,
              item_id: this.props.itemId,
            },
          },
        }).then(this.onSubmitSuccess).catch(this.onSubmitFailure)
    } else {
      this.setState({ disableButton: false })
    }
  }

  onSubmitSuccess() {
    this.onPaginate(this.state.meta.currentPage)
  }

  onSubmitFailure(xhr) {
    App.events.publish('app:notification:flash:error', xhr.response.data.errors[0].detail)

    this.setState({ disableButton: false })
  }

  errorFor(field) {
    if (this.state.validationErrors) {
      return this.state.validationErrors[field] || ''
    }
  }

  onScoreChange(score) {
    this.setState({ score })
  }

  render() {
    const scores = [
      { value: '1', label: 'Positive', icon: ['fas', 'thumbs-up'] },
      { value: '-1', label: 'Negative', icon: ['fas', 'thumbs-down'] },
    ]

    return (
      this.state.itemRatings.length > 0 ? (
        <div className="product-comments">
          <div className="product-ratings">
            <div className="product-ratings__bar">
              Item Rating

              <span className="product-ratings__thumbs">
                <Icon type="thumbs-up" color="green-dark" />
                {this.state.meta.counts.positiveCount}
                <Icon type="thumbs-down" color="grey" />
                {this.state.meta.counts.negativeCount}
              </span>

              <Progressbar
                value={this.state.meta.counts.positiveCount}
                maxValue={this.state.meta.counts.positiveCount + this.state.meta.counts.negativeCount}
                labelSize="label-none"
                barColor="is-dark"
              />
            </div>

            {this.props.isBuyer && (
              <button className="btn btn-primary" type="button" onClick={this.scrollToCommentBox}>Leave a review</button>
            )}
          </div>

          <ul className="comments-list">
            {this.state.itemRatings.map((itemRating) => (
              <ItemRating
                itemRating={itemRating.attributes}
                key={itemRating.id}
                isAdmin={this.state.isAdmin}
                removeItemRating={this.removeItemRating}
                isSignedIn={this.state.isSignedIn}
                itemId={this.props.itemId}
              />
            ))}
          </ul>

          {this.state.meta.counts.totalCount > this.state.meta.perPage && (
            <ReactPagination
              activePage={this.state.meta.currentPage}
              itemsCountPerPage={this.state.meta.perPage}
              totalItemsCount={this.state.meta.counts.totalCount}
              pageRangeDisplayed={5}
              onChange={this.onPaginate}
              firstPageText="First"
              lastPageText="Last"
              innerClass="pagination--grey u-text-right"
              disabledClass="is-disabled"
              activeLinkClass="is-active"
            />
          )}

          <form className="comment-form u-mt10" onSubmit={this.handleSubmit}>
            {this.props.isBuyer && (
              <Fragment>
                <div className="leave-review">
                  <h6>Leave a rating</h6>
                  <CustomRadioBoxes
                    options={scores}
                    selectedValue={this.state.score}
                    onChange={this.onScoreChange}
                  />
                </div>
                <TextareaField
                  label="Write a comment"
                  required
                  id="comment"
                  name="comment"
                  errorText={this.errorFor('comment')}
                  showError={this.state.showErrors}
                  value={this.state.comment}
                  inputClassName="form-control-lg field--important"
                  onChange={this.handleInputChange}
                />
                <div className="u-text-right" ref={this.commentBoxRef}>
                  <button className="btn btn-primary">Post review</button>
                </div>
              </Fragment>
            )}
          </form>
        </div>
      ) : (
        <div className="empty-content u-text-center">
          This product has no reviews yet
        </div>
      )
    )
  }
}

ItemRatings.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.array,
    meta: PropTypes.object,
  }).isRequired,
  itemId: PropTypes.number.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isBuyer: PropTypes.bool,
  isSignedIn: PropTypes.bool.isRequired,
}

ItemRatings.defaultProps = {
  isBuyer: false,
}

export default ItemRatings
